import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';

import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';
import CustomerGateway from '~apis/customer';
import { PayloadAction } from '@reduxjs/toolkit';
import { TGetCustomerFilterReduxParams } from '~types/feat/customer';

export default function* watchGetAllCustomers(api: CustomerGateway): SagaWatcherReturnType {
    yield takeEvery('customer/customerGetAllCustomersAttempt', handleGetAllCustomers, api);
}

function* handleGetAllCustomers(api: CustomerGateway, data: PayloadAction<TGetCustomerFilterReduxParams>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const { searchQuery } = data.payload;

    const response = yield* call([api, api.getAllCustomers], {
        authToken,
        searchQuery,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.customerGetAllCustomersFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.customerGetAllCustomersSuccess(response.data));
    }
}
